/* ByMoove - affichage des variantes (retour visio 06/10)
   Regle : les variantes restent en boutons (pastilles bleues) tant que ca tient sur 2 lignes max.
   Des que l'affichage depasse 2 lignes (PC ou mobile) -> menu deroulant stylise comme un bouton.
   Le champ "couleur / coloris" passe TOUJOURS en menu deroulant (demande Clement).
   Aucune action cote catalogue : purement visuel, 100 % synchronise avec les vrais inputs du theme. */
(function () {
  'use strict';
  var FORCE_DROPDOWN = ['couleur', 'coloris', 'color', 'sellerie'];

  function labelText(lab) {
    if (!lab) return '';
    var clone = lab.cloneNode(true);
    var hidden = clone.querySelectorAll('.visually-hidden, .sr-only, [class*="visually-hidden"], [class*="sr-only"], [hidden]');
    for (var i = 0; i < hidden.length; i++) hidden[i].remove();
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function optionName(group) {
    var r = group.querySelector('input[type="radio"]');
    var n = r ? (r.name || '') : '';
    return n.replace(/-\d+\s*$/, '').trim().toLowerCase();
  }

  function countLines(group) {
    var labels = group.querySelectorAll('label');
    var tops = [];
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (l.offsetParent === null) continue;
      var t = Math.round(l.getBoundingClientRect().top);
      var seen = false;
      for (var j = 0; j < tops.length; j++) { if (Math.abs(tops[j] - t) < 4) { seen = true; break; } }
      if (!seen) tops.push(t);
    }
    return tops.length;
  }

  function buildSelect(group) {
    var radios = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
    if (radios.length < 2) return;
    var sel = document.createElement('select');
    sel.className = 'bm-variant-select';
    sel.setAttribute('aria-label', 'Choisir une option');
    radios.forEach(function (r) {
      var lab = group.querySelector('label[for="' + r.id + '"]');
      var txt = labelText(lab) || r.value;
      var o = document.createElement('option');
      o.value = r.id;
      o.textContent = r.disabled ? (txt + ' (indisponible)') : txt;
      if (r.checked) o.selected = true;
      if (r.disabled) o.disabled = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      var r = document.getElementById(sel.value);
      if (!r) return;
      if (!r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('input', { bubbles: true }));
        r.dispatchEvent(new Event('change', { bubbles: true }));
        var lab = group.querySelector('label[for="' + r.id + '"]');
        if (lab && typeof lab.click === 'function') lab.click();
      }
    });
    group.appendChild(sel);
    group.classList.add('bm-variant-asdropdown');
  }

  function removeSelect(group) {
    var sel = group.querySelector('.bm-variant-select');
    if (sel) sel.remove();
    group.classList.remove('bm-variant-asdropdown');
  }

  function syncSelect(group) {
    var sel = group.querySelector('.bm-variant-select');
    if (!sel) return;
    var checked = group.querySelector('input[type="radio"]:checked');
    if (checked && sel.value !== checked.id) sel.value = checked.id;
  }

  function process() {
    var groups = document.querySelectorAll('.product-form__input--button');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var hasSelect = !!group.querySelector('.bm-variant-select');
      var name = optionName(group);
      var force = FORCE_DROPDOWN.some(function (w) { return name.indexOf(w) !== -1; });
      // mesurer en mode boutons : retirer temporairement le select pour compter les lignes
      if (hasSelect && !force) { group.classList.remove('bm-variant-asdropdown'); }
      var lines = force ? 99 : countLines(group);
      var wantDropdown = force || lines > 2;
      if (wantDropdown && !hasSelect) buildSelect(group);
      else if (!wantDropdown && hasSelect) removeSelect(group);
      else if (hasSelect) { group.classList.add('bm-variant-asdropdown'); syncSelect(group); }
    }
  }

  function run() { try { process(); } catch (e) {} }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 200); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.product-form__input--button input')) setTimeout(run, 60);
  });
  // le theme re-rend parfois la fiche (changement de variante) : on repasse apres un court delai
  document.addEventListener('variant:change', function () { setTimeout(run, 80); });

  // Horizon re-rend tout le selecteur a chaque changement de variante (remplacement du DOM),
  // ce qui faisait "revenir" les pastilles apres un choix dans le menu deroulant.
  // Un MutationObserver re-applique la conversion de maniere fiable des que le DOM produit change.
  function observe() {
    var root = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
    if (!root || root.__bmVarObs) return;
    root.__bmVarObs = true;
    var deb;
    var mo = new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(run, 50); });
    mo.observe(root, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') observe();
  else document.addEventListener('DOMContentLoaded', observe);
})();
